<div class="grid__cell grid__cell--widget grid__cell--widget-dashboard widget__bag"
     [dragula]='"widget-bag"'>
  <div class="widget__wrap">
    <div class="widget"
         id="categories-widget">
      <h2 class="widget__header">
        <span class="widget__header__title">
          <i class="widget__header__icon ico-angle-down"></i> Pracovní nabídky</span>
        <span class="widget__header__tools">
          <swb-filter-list (modelChange)="filter($event)"></swb-filter-list>
          <a [routerLink]="['jobs/add']"
             class="cta cta--small cta--green">
            <span class="cta__light">Přidat</span> nabídku
            <i class="ico-plus"></i>
          </a>
        </span>
      </h2>
      <div class="widget__content">
        <swb-job-list [query]="query"></swb-job-list>
      </div>
    </div>
  </div>
</div>
<div class="grid__cell grid__cell--widget grid__cell--widget-dashboard widget__bag"
     [dragula]='"widget-bag"'>
  <swb-career-desc></swb-career-desc>
</div>